import { connect } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
// Gojko
import { ReactComponent as LogoSO } from "../../assets/images/smartocto-logo.svg";
import { ReactComponent as LogoSOLight } from "../../assets/images/smartocto-logo-light.svg";
import {IBrandSettings, IDashboardConfig} from "../../constants/interfaces";
import DashboardNavigation from "../dashboardNavigation/DashboardNavigation";

type Props = {
	data: IDashboardConfig,
	theme: string,
	brand: IBrandSettings,
	hasNavigation? : boolean
};

const Header = (props: Props) => {
	const { data, theme, brand } = props;
	const [currentTheme, setCurrentTheme] = useState(theme);
	const { id } = useParams() as any;

	const isCurrent = useMemo(()=>{
		if (id.toLowerCase().includes("current") || id.toLowerCase().includes("readingtime")) {
			return true;
		} return false;
	},[id])

	useEffect(()=>{
		const savedTheme = window.localStorage.getItem("theme");

		if (!savedTheme) {
			window.localStorage.setItem("theme", "dark")
		}
		else {
			if (savedTheme === "dark") {
				setCurrentTheme("dark");
				window.localStorage.setItem("theme", "dark");
				document.body.classList.remove("light");
			} else {
				setCurrentTheme("light");
				window.localStorage.setItem("theme", "light");
				document.body.classList.add("light");
			}
		}
	}, [])

	const toggleColorTheme = () => {
		if (currentTheme === "light") {
			setCurrentTheme("dark");
			window.localStorage.setItem("theme", "dark");
			document.body.classList.remove("light");
		} else {
			setCurrentTheme("light");
			window.localStorage.setItem("theme", "light");
			document.body.classList.add("light");
		}
	};

	const setBrand = () => {
		const logo = Object.keys(brand).length > 0 && brand.domainSettings ? brand.domainSettings.domainlogo : null;
		if (logo) {
			return (
				<div className="header__brands">
					<div className="header-brand">
						<img src={logo} alt="brand" />
					</div>
					{
						data.image && (
							<div className="header-brand">
								<img src={data.image} alt="brand" />
							</div>
						)
					}

				</div>
			);
		}
	};

	return (
		<div className="header">
			<div className="header__align-left">
				{setBrand()}
				{
					!props.hasNavigation && <div className="header__info">{data.description}</div>
				}
				{
					(props.hasNavigation && !isCurrent) && <DashboardNavigation theme={currentTheme} />
				}

				{/*<div className={`header__nav active-${activeGrid}`}>*/}
				{/*	<div*/}
				{/*		className="nav nav1"*/}
				{/*		onClick={() => switchLayout(1)}*/}
				{/*	></div>*/}
				
				{/*	<div*/}
				{/*		className="nav nav2"*/}
				{/*		onClick={() => switchLayout(2)}*/}
				{/*	></div>*/}
				
				{/*	<div*/}
				{/*		className="nav nav3"*/}
				{/*		onClick={() => switchLayout(3)}*/}
				{/*	></div>*/}
				{/*</div>*/}
			</div>

			<div
				className="header__align-right"
				onClick={() => toggleColorTheme()}
			>
				{currentTheme === "light" ? <LogoSOLight /> : <LogoSO />}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	return { dashboard: state.dashboard };
};

export default connect(mapStateToProps)(Header);
